module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vacancy"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": _vm.vacancy.url
    }
  }, [_vm._v(_vm._s(_vm.vacancy.title))]), _c('br'), _vm._v(_vm._s(_vm.vacancy.description))]), _vm._v(" "), _c('a', {
    staticClass: "hh",
    attrs: {
      "href": _vm.vacancy.url
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.hh
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "sj",
    attrs: {
      "href": _vm.vacancy.url
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.sj
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7629d590"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vacancy/Vacancy.vue
// module id = 134
// module chunks = 0